import { createApi } from '@reduxjs/toolkit/query/react';
import { resolveModuleType } from "../../config/moduleTypes";
import {baseQueryWithReauth} from "../../api/baseQuery";

export const templateApi = createApi({
    reducerPath: 'templateApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        fetchTemplate: builder.query({
            query: ({templateId, moduleType}) => {
                const type = resolveModuleType(moduleType);
                return { url: type?.endpoints.getDetails, params: { templateId } };
            },
        }),
    }),
})

export const { useFetchTemplateQuery } = templateApi;
